import script from "./RequestsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsTable.vue?vue&type=script&setup=true&lang=js"

import "./RequestsTable.vue?vue&type=style&index=0&id=12d389a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d389a4"]])

export default __exports__